import KeyValue from "components/KeyValue";
import Link from "ds/components/Link";
import { CLOUD_INTEGRATIONS } from "shared/CloudIntegration/types";
import { getCloudIntegrationUrl } from "shared/CloudIntegration/urls";
import { StackAwsIntegrationAttachment } from "types/generated";
import { getDuration } from "utils/time";

type AttachCloudDetailsAWSFieldsProps = {
  integration: StackAwsIntegrationAttachment;
};

const AttachCloudDetailsAWSFields = ({ integration }: AttachCloudDetailsAWSFieldsProps) => {
  const integrationUrl = getCloudIntegrationUrl(CLOUD_INTEGRATIONS.AWS, integration.integrationId);

  return (
    <>
      <KeyValue name="Name">
        <Link href={integrationUrl} variant="secondary">
          {integration.name}
        </Link>
      </KeyValue>
      <KeyValue name="Role ARN">{integration.roleArn}</KeyValue>
      <KeyValue name="Duration">{getDuration(integration.durationSeconds)}</KeyValue>
      <KeyValue name="External Id">{integration.externalId}</KeyValue>
    </>
  );
};

export default AttachCloudDetailsAWSFields;
